import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'

import { useIntl } from 'gatsby-plugin-intl'
import { breakpoint } from 'src/theme/grid'

import HeaderLoggedIn, {
  HeaderGroup
} from 'src/components/header/HeaderLoggedIn'
import Tabs from 'src/components/Tabs'
import { Page } from 'src/components/Wrappers'
import Alert from 'src/components/Alert'
import { Column, Row, SectionBox } from 'src/features/account/components/atoms'
import { MY_OFFERS_TABS_ARRAY } from 'src/features/myOffers/duck/consts'
import routes from 'src/utils/routes'
import BreadCrumbs from 'src/components/BreadCrumbs'
import { MENU_ITEMS } from 'src/features/dashboard/duck/consts'
import { Padding } from 'src/features/myOffers/components/atoms'
import { connectImportReservations } from 'src/features/reservations/duck/connectors'
import ReservationsListOngoing from 'src/features/reservations/components/import/ReservationsListOngoing'
import ReservationsListFinished from 'src/features/reservations/components/import/ReservationsListFinished'
import StockHeader from 'src/features/stocks/components/StockHeader.jsx'
import Drawer from 'src/features/stocks/components/Drawer'
import OfferHistoryDetails from 'src/features/stocks/components/OfferDetails/OfferHistoryDetails'
import { ContentWrapper } from 'src/features/stocks/components/atoms'
import { EXCHANGE_MAP_TYPES } from 'src/features/stocks/components/map/offerMapUtils'
import { showImportOfferDetailsRoutine } from 'src/features/stocks/ducks/actions-import'
import { showExportOfferDetailsRoutine } from 'src/features/stocks/ducks/actions-export'
import { showGeneralOfferDetailsRoutine } from 'src/features/stocks/ducks/actions-general-cargo'

const ROUND_TRIP_DRAWER_ACTIONS = {
  [EXCHANGE_MAP_TYPES.IMPORT]: showImportOfferDetailsRoutine,
  [EXCHANGE_MAP_TYPES.EXPORT]: showExportOfferDetailsRoutine,
  [EXCHANGE_MAP_TYPES.GENERAL]: showGeneralOfferDetailsRoutine
}

const MyImportReservations = ({
  className,
  getMyOngoingReservations,
  getMyFinishedReservations
}) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const initialActiveTab = 0
  const [isRoundTripDrawerOpen, setRoundTripDrawerOpen] = useState(false)
  const [roundTripDrawerOfferType, setRoundTripDrawerOfferType] = useState(
    EXCHANGE_MAP_TYPES.IMPORT
  )
  const [selectedRoundTripOfferId, setSelectedRoundTripOfferId] = useState(null)
  const [selectedRoundTripOfferType, setSelectedRoundTripOfferType] = useState(
    EXCHANGE_MAP_TYPES.IMPORT
  )

  const showRoundTripOfferDetails = useCallback(
    (offerType, offerId) => {
      const showDetails = ROUND_TRIP_DRAWER_ACTIONS[offerType]
      if (!showDetails) return

      setRoundTripDrawerOfferType(offerType)
      setSelectedRoundTripOfferId(offerId)
      setSelectedRoundTripOfferType(offerType)
      setRoundTripDrawerOpen(true)
      dispatch(showDetails({ id: offerId, query: { origin: 'drawer' } }))
    },
    [dispatch]
  )

  const handleRoundTripOfferSelect = useCallback(
    mapOffer => showRoundTripOfferDetails(mapOffer.exchangeType, mapOffer.id),
    [showRoundTripOfferDetails]
  )

  const showImportOffer = useCallback(
    offerId => showRoundTripOfferDetails(EXCHANGE_MAP_TYPES.IMPORT, offerId),
    [showRoundTripOfferDetails]
  )

  const closeRoundTripDrawer = useCallback(
    () => setRoundTripDrawerOpen(false),
    []
  )

  useEffect(() => {
    getMyOngoingReservations()
    getMyFinishedReservations()
  }, [])

  return (
    <Page
      className={className}
      contentPadding={0}
      topBar={
        <HeaderLoggedIn>
          <HeaderGroup>
            <StockHeader withDropdown>
              {intl.formatMessage({
                id: 'reservations.titleImport'
              })}
            </StockHeader>
          </HeaderGroup>
        </HeaderLoggedIn>
      }
    >
      <ReservationsWorkspace>
        <ReservationsContent>
          <Padding>
            <BreadCrumbs
              links={[
                {
                  name: intl.formatMessage({ id: 'forms.dashboard' }),
                  url: `${routes.APP_DASHBOARD}?tab=${MENU_ITEMS.DASHBOARD}`
                },
                {
                  name: intl.formatMessage({
                    id: 'offers.freightExchangeImportTitle'
                  }),
                  url: `${routes.APP_DASHBOARD}?tab=${MENU_ITEMS.STOCKS_CARGO_IMPORT}`
                },
                {
                  name: intl.formatMessage({
                    id: 'reservations.title'
                  }),
                  url: `${routes.APP_DASHBOARD}?tab=${MENU_ITEMS.MY_IMPORT_RESERVATIONS}`
                }
              ]}
            />
          </Padding>
          <Tabs list={MY_OFFERS_TABS_ARRAY} initialActiveTab={initialActiveTab}>
            <SectionBox>
              <Row>
                <Column>
                  <Row>
                    <Column>
                      <ReservationsListOngoing
                        isRoundTripDrawerOpen={isRoundTripDrawerOpen}
                        onRoundTripDrawerOfferTypeChange={
                          setRoundTripDrawerOfferType
                        }
                        onRoundTripOfferSelect={handleRoundTripOfferSelect}
                        selectedRoundTripOfferId={selectedRoundTripOfferId}
                        selectedRoundTripOfferType={selectedRoundTripOfferType}
                        setRoundTripDrawerState={setRoundTripDrawerOpen}
                        showRoundTripOffer={showImportOffer}
                      />
                    </Column>
                  </Row>
                </Column>
              </Row>
            </SectionBox>
            <SectionBox>
              <Row>
                <Column>
                  <Row>
                    <Column>
                      <ReservationsListFinished
                        isRoundTripDrawerOpen={isRoundTripDrawerOpen}
                        onRoundTripDrawerOfferTypeChange={
                          setRoundTripDrawerOfferType
                        }
                        onRoundTripOfferSelect={handleRoundTripOfferSelect}
                        selectedRoundTripOfferId={selectedRoundTripOfferId}
                        selectedRoundTripOfferType={selectedRoundTripOfferType}
                        setRoundTripDrawerState={setRoundTripDrawerOpen}
                        showRoundTripOffer={showImportOffer}
                      />
                    </Column>
                  </Row>
                </Column>
              </Row>
            </SectionBox>
          </Tabs>
        </ReservationsContent>
        <ReservationsDrawer
          open={isRoundTripDrawerOpen}
          onClose={closeRoundTripDrawer}
        >
          <OfferHistoryDetails
            defaultOfferType={roundTripDrawerOfferType}
            isOpen={isRoundTripDrawerOpen}
            offerType={roundTripDrawerOfferType}
            onActiveOfferChange={({ id, offerType }) => {
              setSelectedRoundTripOfferId(id)
              setSelectedRoundTripOfferType(offerType)
            }}
            onClose={closeRoundTripDrawer}
            onOfferTypeChange={setRoundTripDrawerOfferType}
            selectedOfferId={`${roundTripDrawerOfferType}:${selectedRoundTripOfferId ||
              ''}`}
          />
        </ReservationsDrawer>
      </ReservationsWorkspace>
    </Page>
  )
}

const ReservationsWorkspace = styled(ContentWrapper)`
  height: 100%;
  min-height: 0;
`

const ReservationsContent = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`

const ReservationsDrawer = styled(Drawer)`
  ${breakpoint.m`
    min-width: ${({ open }) => (open ? '400px' : '0')};
    flex: ${({ open }) => (open ? '0 0 400px' : '0 0 0')};
  `}
`

const ConnectedComponent = connectImportReservations(MyImportReservations)

export default styled(ConnectedComponent)`
  ${Tabs} {
    display: block;
    margin-bottom: 0;
    & > div {
      padding: 0.75rem 1.2rem 0 1.2rem;
    }
    & span {
      font-weight: 400;
    }
  }

  ${Alert} {
    width: auto;
    margin: 1rem 0 0 0;
    ${breakpoint.m`
    margin: initial;
    width: inherit;
  `}
  }
  ${SectionBox} {
    padding: 0 0 180px 0;
    ${breakpoint.m`
      padding: 0 1.2rem 180px 1.2rem;
  `}
  }
`
